import { render } from "./SavingMoneyBuyRecord.vue?vue&type=template&id=1e52f026&scoped=true"
import script from "./SavingMoneyBuyRecord.vue?vue&type=script&lang=js"
export * from "./SavingMoneyBuyRecord.vue?vue&type=script&lang=js"

import "./SavingMoneyBuyRecord.vue?vue&type=style&index=0&id=1e52f026&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e52f026"]])

export default __exports__